<div class="w-full bg-orange min-h-11 lg:min-h-16 items-center pl-5 lg:pl-12 xs:flex hidden">
    <img src="layouts/common/images/olva-logo.svg" alt="Logo" class="h-5 lg:h-8" />
</div>
